
"use client";
import React from "react";
import { ConfigProvider } from "antd";
import theme from "../libs/theme";
import { getItem } from "sharedresources";
export var dir = typeof window !== "undefined" && (getItem("lng") === "ar" || getItem("lng") === "he") ? "rtl" : "ltr";
export default function DirectionSetter({ children }) {

    const lang = typeof window !== "undefined" ? getItem('language') || 'en' : 'en';
    const direction = lang === "ar" ? "rtl" : "ltr";

    if (typeof window !== "undefined") {
        document.documentElement.setAttribute("dir", direction);
        document.documentElement.lang = lang;
        document.documentElement.dir = direction;
    }

    return (
        <ConfigProvider direction={direction} theme={theme}>
            {children}
        </ConfigProvider>
    );
}

